import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryField } from 'shared/summary/SummaryField';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useRentalSteps } from '../../app/steps';
import { BaseSummaryProps } from './types';


export const AdditionalInfoSummary = ({ application }: BaseSummaryProps) => {
  const steps = useRentalSteps({slug: slugs.additionalInfo});
  const customer = application?.customer;
  const errors = application?.validation?.customer;
  
  return (
    <SummarySection>
      <SummaryHeader step={steps.this}>Anything Else We Need to Know</SummaryHeader>
      {!customer ? <LoadingLabel alignment="left" /> : (
        <SummaryField label="" field="workComments" value={!customer.workComments ? 'None specified' : customer.workComments} errors={errors} />
      )}
    </SummarySection>
  );
}